import TrunksAPI from 'dashboard/api/asterisk/trunks';
import { createHandleRealtimeEvent } from './_helpers/asteriskRealtime';
import { createPendingOp } from './_helpers/asteriskAsyncOp';

const RESOURCE = 'trunk';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getByName: $state => name =>
    $state.records.find(r => r.trunk_name === name || r.name === name),
  getById: $state => id =>
    $state.records.find(r => r.id === id || r.trunk_name === id),
  getTrunksByType: $state => type =>
    $state.records.filter(r => r.trunk_type === type),
};

export const actions = {
  // Recebe broadcast ActionCable disparado pelo ApiCallJob (TrunksService) e
  // resolve a Promise pendente do create/update/delete via resolvePendingOp.
  handleRealtimeEvent: createHandleRealtimeEvent('fetch', RESOURCE),

  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await TrunksAPI.get();
      const trunks = response.data.trunks || [];
      commit('SET_RECORDS', trunks);
      return trunks;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show(_, trunkName) {
    const response = await TrunksAPI.show(trunkName);
    return response.data.trunk;
  },

  // Backend retorna 202 (job enfileirado). Promise resolve quando broadcast
  // `asterisk.trunk.changed` confirma — permite toast.promise no form.
  async create({ commit }, data) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      await TrunksAPI.create({ trunk: data });
      await createPendingOp(RESOURCE, 'created', data.trunk_name);
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { trunkName, data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      await TrunksAPI.update(trunkName, { trunk: data });
      await createPendingOp(RESOURCE, 'updated', trunkName);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, trunkName) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await TrunksAPI.delete(trunkName);
      await createPendingOp(RESOURCE, 'deleted', trunkName);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_RECORDS($state, records) {
    $state.records = records;
  },

  ADD_RECORD($state, record) {
    $state.records.push(record);
  },

  UPDATE_RECORD($state, { trunkName, data }) {
    const index = $state.records.findIndex(
      r => r.trunk_name === trunkName || r.name === trunkName
    );
    if (index !== -1) {
      $state.records[index] = { ...$state.records[index], ...data };
    }
  },

  DELETE_RECORD($state, trunkName) {
    $state.records = $state.records.filter(
      r => r.trunk_name !== trunkName && r.name !== trunkName
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
